// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--c2524";
export var headingContainer = "index-module--heading-container--1f1ab";
export var highlight = "index-module--highlight--e457a";
export var highlightLine = "index-module--highlight-line--9cdc8";
export var image1 = "index-module--image-1--613eb";
export var image2 = "index-module--image-2--dcbb1";
export var imageContainer = "index-module--image-container--4fa43";